export const CHART_COLORS = {
  Battery_Charge: '#038BA8',
  Battery_Discharge: '#AC44FB',
  Battery_State_of_Charge: '#AC99FB',
} as const;
